/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Region_Lower_BodyInputs */

const en_us2_exercise_region_lower_body = /** @type {(inputs: Exercise_Region_Lower_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lower body`)
};

const pt_br2_exercise_region_lower_body = /** @type {(inputs: Exercise_Region_Lower_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parte inferior`)
};

const es_419_exercise_region_lower_body = /** @type {(inputs: Exercise_Region_Lower_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tren inferior`)
};

const pt_pt2_exercise_region_lower_body = /** @type {(inputs: Exercise_Region_Lower_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parte inferior`)
};

const fr_fr2_exercise_region_lower_body = /** @type {(inputs: Exercise_Region_Lower_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bas du corps`)
};

const de_de2_exercise_region_lower_body = /** @type {(inputs: Exercise_Region_Lower_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterkörper`)
};

const it_it2_exercise_region_lower_body = /** @type {(inputs: Exercise_Region_Lower_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parte inferiore`)
};

/**
* | output |
* | --- |
* | "Lower body" |
*
* @param {Exercise_Region_Lower_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_region_lower_body = /** @type {((inputs?: Exercise_Region_Lower_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Region_Lower_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_region_lower_body(inputs)
	if (locale === "es-419") return es_419_exercise_region_lower_body(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_region_lower_body(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_region_lower_body(inputs)
	if (locale === "de-DE") return de_de2_exercise_region_lower_body(inputs)
	if (locale === "it-IT") return it_it2_exercise_region_lower_body(inputs)
	return en_us2_exercise_region_lower_body(inputs)
});
export { exercise_region_lower_body as "exercise.region_lower_body" }